import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CreationFormWrapper from "../../actprep-ui/components/CreationFormWrapper";
import { usePost, usePut } from "../../actprep-ui/hooks/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";

export default function VideoForm({
  open,
  setOpen,
  initialValue,
  setValue,
  initialUUID,
  DialogProps,
}) {
  const editing = Boolean(initialUUID);
  const createVideoMutation = usePost(apiUrls.admin.videos());
  const editVideoMutation = usePut(apiUrls.admin.videos());
  const [formData, setFormData] = useState({
    title: "",
    embed_link: "",
  });
  const handleFocus = () => setError(null);
  const [error, setError] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let response;
    if (editing) {
      response = await editVideoMutation.mutateAsync({
        ...formData,
        video_uuid: initialUUID,
      });
    } else {
      response = await createVideoMutation.mutateAsync(formData);
    }
    const { data } = response;
    if (!data.success) {
      setError(data.reason);
      return;
    }
    setValue({
      uuid: data.data.uuid,
      label: data.data.title,
    });
    setOpen(false);
    if (editing) {
      showSuccessSnackbar("Video Updated!");
      return;
    }
    showSuccessSnackbar("New Video Created!");
  };

  useEffect(() => {
    if (open) {
      setFormData((formData) => ({
        ...formData,
        title: initialValue,
      }));
    }
  }, [open, initialValue]);

  return (
    <CreationFormWrapper
      open={open}
      onClose={handleClose}
      onSubmit={onSubmit}
      error={error}
      title={editing ? `Editing '${initialValue}' Video` : "Add a new Video"}
      confirmText={editing ? "Save" : "Create"}
      DialogProps={DialogProps}
    >
      <Grid container gap={3} marginTop={1}>
        <Grid size={12}>
          <TextField
            required
            fullWidth
            autoFocus
            value={formData.title}
            onChange={(event) =>
              setFormData({
                ...formData,
                title: event.target.value,
              })
            }
            label="Title"
            type="text"
            variant="standard"
            onFocus={handleFocus}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            required
            fullWidth
            autoFocus
            value={formData.embed_link}
            onChange={(event) =>
              setFormData({
                ...formData,
                embed_link: event.target.value,
              })
            }
            label="Embed Link"
            type="url"
            variant="standard"
            onFocus={handleFocus}
          />
        </Grid>
      </Grid>
    </CreationFormWrapper>
  );
}
